import React from 'react'
import { DevPanelData } from '../types'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import { useAppSelector } from 'hooks/reduxHooks'
import ExpandableObjectView from '../ExpandableObjectView'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import TextLink from 'LuxKit/TextLink'

interface Props {
  state: DevPanelData
}

function ReduxStateTab({ state: _devPanelState }: Props) {
  // Normally it would be bad practice to return the entire state from a selector,
  // but in this case showing the entire state is the whole point of the component.
  const reduxState = useAppSelector(state => state)

  return <Pane padding={20}>
    <VerticalSpacer gap={16}>
      <Heading variant="heading5">Redux state</Heading>

      <ExpandableObjectView value={reduxState} initialExpanded />

      <MessageBanner kind="informational-primary">
        See also: <TextLink href="https://chromewebstore.google.com/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en" target="_blank" rel="noopener noreferrer">Redux DevTools</TextLink>
      </MessageBanner>
    </VerticalSpacer>
  </Pane>
}

export default ReduxStateTab
